import React, { useState } from "react";
import classes from "./ContactInfo.module.css";

const ContactInfo = ({ onPrevious, onNext, formData, setFormData }) => {
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    setErrors((prev) => ({ ...prev, [name]: null }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Let parent handle validation
    onNext();
  };

  return (
    <div className={classes.container}>
      <form onSubmit={handleSubmit} className={classes.form}>

        {/* Contact Information */}
        <div className={classes.section}>
          <h3 className={classes.sectionTitle}>Contact Information</h3>
          <p className={classes.sectionSubtitle}>Please provide contact details for the patient</p>

          <div className={classes.row2Col}>
            <div className={classes.inputGroup}>
              <label>Primary Phone Number <span className={classes.required}>*</span></label>
              <input
                type="text"
                name="phone"
                placeholder="Enter primary phone number"
                className={`${classes.formInput} ${errors.phone ? classes.inputError : ""}`}
                value={formData.phone || ""}
                onChange={handleChange}
              />
              {errors.phone && <span className={classes.errorText}>{errors.phone}</span>}
            </div>

            <div className={classes.inputGroup}>
              <label>Alternative Phone Number</label>
              <input
                type="text"
                name="alternativePhone"
                placeholder="Enter alternative phone number"
                className={classes.formInput}
                value={formData.alternativePhone || ""}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className={classes.row2Col}>
            <div className={classes.inputGroup}>
              <label>Email Address <span className={classes.required}>*</span></label>
              <input
                type="email"
                name="email"
                placeholder="Enter email address"
                className={`${classes.formInput} ${errors.email ? classes.inputError : ""}`}
                value={formData.email || ""}
                onChange={handleChange}
              />
              {errors.email && <span className={classes.errorText}>{errors.email}</span>}
            </div>

            <div className={classes.inputGroup}>
              <label>Preferred Language</label>
              <select
                name="preferredLanguage"
                className={classes.formSelect}
                value={formData.preferredLanguage || ""}
                onChange={handleChange}
              >
                <option value="">Select preferred language</option>
                <option>English</option>
                <option>Yoruba</option>
                <option>Hausa</option>
                <option>Igbo</option>
                <option>French</option>
              </select>
            </div>
          </div>

     
        </div>

        {/* Footer Navigation */}
        <div className={classes.footer}>
          <div className={classes.note}>
            Contact information will be used for appointments,
            notifications and other important patient communications.
          </div>
          <div className={classes.footerButtons}>
            <button type="button" className={classes.previousBtn} onClick={onPrevious}>
              ← Previous
            </button>
            <button type="submit" className={classes.nextBtn}>
              Next →
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ContactInfo;